<template>
    <div class="home-page">
		<Header></Header>
		<div class="content por">
      <div class="promo-copy">
        <div class="promo-copy__badge">1GB ဒေတာ ပိုင်ဆိုင်ခွင့်!</div>
        <div class="promo-copy__desc">
          ဂိမ်းရွာ သုံးစွဲသူများအတွက် သီးသန့် အထူးအစီအစဉ်ကြီး လာပါပြီ။ ဒီဇူလိုင်လကုန်မှာ
          ATOM 1GB ဒေတာပက်ကေ့ချ်ကို ၃ကြိမ်နှင့်အထက်ဝန်ဆောင်မှုရယူထားသူ အယောက် (၁၀၀) တိတိ အား လက်ဆောင်ပေးသွားပါမည်။
        </div>
      </div>
      <div class="home-search disflex">
        <input ref="input" v-model="keywords" @blur="getSearch()"
          @keyup.enter.native="getSearch($event)" class="input" />
        <img @click="getSearch(keywords)" src="../../static/images/search-icon.png" />
      </div>
      <div class="home1 home1-bg ">
        <div class="por" style="margin-bottom:70px;">
          <div class="mission-t redeem-t" style="font-size:40px;">{{$t('FeaturedGames')}}</div>
          <div class="home1-xing">
              <img v-for="i in 10" src="../../static/images/xing.png">
          </div>
        </div>
        <div class="home1-product">
          <div class="home1-list" v-for="(item,index) in info.recommend">
              <div class="home1-img" @click="goPlay(item.game_id)">
                <img :src="item.icon_image" />
              </div>
              <div class="name-title ovhidden" @click="goPlay(item.game_id)">
                {{item.title}}
              </div>
              <button class="btn btn-blue" @click="goPlay(item.game_id)">{{$t('play')}}</button>
          </div>
        </div>
        <div class="home1-banner mt50">
          <img src="../../static/images/banner1.jpg">
          <img src="../../static/images/banner2.jpg">
          <img src="../../static/images/banner3.jpg">
        </div>
        <div class="home1-product2">
          <div class="product2-title disflex flex-between">
            <div class="title fw7">{{$t('Populargames')}}</div>
            <router-link :to="{path:'/list'}" class="more">{{$t('viewAll')}}</router-link>
          </div>
          <div class="product2-content disflex">
            <div class="product2-list" v-for="(item,index) in info.hot">
              <div class="home1-img2" @click="goPlay(item.game_id)">
                <img :src="item.icon_image" />
              </div>
              <div class="product2-bottom" @click="goPlay(item.game_id)">
                <div class="name-title ovhidden">
                  {{item.title}}
                </div>
                <button class="btn btn-blue" @click="goPlay(item.game_id)">{{$t('play')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>
    <div class="home-bottom ac">
      <div class="home-text">
        <span class="strong">GAmeywar</span>
          <router-link :to="{path:'/myAccount'}">{{$t('myAccount')}}</router-link>
         <!-- <router-link :to="{path:'/changePassword'}">{{$t('ChangePassword')}}</router-link> -->
          <router-link :to="{path:'/faq'}">{{$t('FAQs')}}</router-link>
          <router-link :to="{path:'/termsAndCondition'}">{{$t('TC')}} </router-link>
          <router-link :to="{path:'/language'}">{{$t('language')}}</router-link>
      </div>
      <div class="copyright">{{$t('Copyright')}}</div>
    </div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			info:{},
      isShow:false,
      keywords:''
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
    if (this.$route.query.mobile){
      this.getUserLogin()
    }else {
      this.getHome();
    }
	},
    methods: {
      getUserLogin(){
        let that = this
        let data = {
          mobile:this.$route.query.mobile
        }
        that.$api.post('/api/user/login',data,r =>{
          that.$parent.returnCode(r,function(){
            localStorage.setItem('token',r.data.userinfo.token)
          })
          this.getHome();
        })
      },
      getHome(){
        let that = this
        that.$api.post('/api/index/index',null,r =>{
        	that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.info = r.data
        	})
        })
      },
      goPlay(game_id){
        this.$router.push({path:'/game',query:{game_id:game_id}});
      },
      getSearch(keywords){
        this.$router.push({path:'/searchList',query:{keywords:this.keywords}});
      },
	}
}
</script>
<style scoped>
.promo-copy {
  width: calc(100% - 70px);
  margin: 0 auto 32px;
  padding: 24px 26px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 24px;
  background: linear-gradient(135deg, rgba(14, 33, 78, 0.92), rgba(67, 23, 116, 0.88));
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  color: #fff;
  text-align: left;
}

.promo-copy__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 138px;
  height: 42px;
  padding: 0 18px;
  margin-bottom: 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, #ffd76a, #ff9f43);
  box-shadow: 0 8px 18px rgba(255, 159, 67, 0.28);
  color: #532200;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 1px;
}

.promo-copy__desc {
  font-size: 24px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.92);
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue